import React from "react";
import NavBar from "../../components/Navbar/Navbar";
import svg from "./404-2.svg";

const NotFound = () => {
  return (
    <>
      <NavBar />
      <div className="columns">
        <div className="column">
          <section className="section">
            <div className="container">
              {/* <h1 className="title is-1 has-text-centered">
                Pagina niet gevonden (404)
              </h1> */}
              <img src={svg} height="500" />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default NotFound;
